var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SidbearSettingsGroup',{attrs:{"title":"Comments List","active":""}},[_c('sid-checkbox',{attrs:{"unchecked-value":"block","value":"none","rule-name":"display","sid":`.--${_vm.section.sid} .comment-avatar`}},[_vm._v(" Hide Avatar ")]),_c('sid-checkbox',{attrs:{"unchecked-value":"block","value":"none","rule-name":"display","sid":`.--${_vm.section.sid} .comment-user-name`}},[_vm._v(" Hide Author Name ")]),_c('sid-checkbox',{attrs:{"unchecked-value":"block","value":"none","rule-name":"display","sid":`.--${_vm.section.sid} .comment-date`}},[_vm._v(" Hide Date ")]),_c('sid-checkbox',{attrs:{"unchecked-value":"block","value":"none","rule-name":"display","sid":`.--${_vm.section.sid} .total-comments`}},[_vm._v(" Hide Total Comments ")]),_c('sid-checkbox',{attrs:{"unchecked-value":"column","value":"column-reverse","rule-name":"flex-direction","sid":`.--${_vm.section.sid}.comments-container`}},[_vm._v(" Swap Comments Box ")]),_c('b-form-group',[_c('b-checkbox',{model:{value:(_vm.section.options.content.comments.gravatar),callback:function ($$v) {_vm.$set(_vm.section.options.content.comments, "gravatar", $$v)},expression:"section.options.content.comments.gravatar"}},[_vm._v(" Gravatar ")])],1),_c('b-form-group',[_c('b-checkbox',{model:{value:(_vm.section.options.content.comments.reply),callback:function ($$v) {_vm.$set(_vm.section.options.content.comments, "reply", $$v)},expression:"section.options.content.comments.reply"}},[_vm._v(" Allow Reply ")])],1),_c('b-form-group',[_c('sid-range-slider',{attrs:{"label":"Height","sid":`.--${_vm.section.sid} .comments-box`,"rule-name":"max-height","var":"--height","reset-value":"300px","measurement":"height","default-dimension":"px","dimensions":[]}})],1),_c('b-form-group',[_c('sid-range-slider',{attrs:{"label":"Vertical Gap","sid":`.--${_vm.section.sid} .comments-box`,"rule-name":"row-gap"}})],1),_c('sid-background',{attrs:{"sid":`.--${_vm.section.sid} .comments-box`}}),_c('sid-linked-group',{attrs:{"label":"Padding","sid":`.--${_vm.section.sid} .comments-box`,"rule-name":"padding","min":0,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}}),_c('sid-linked-group',{attrs:{"label":"Margin","sid":`.--${_vm.section.sid} .comments-box`,"rule-name":"margin","min":0,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Comment"}},[_c('b-form-group',{attrs:{"label":"Text Color"}},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid} .comments-box .comment-text`,"rule-name":"color"}})],1),_c('sid-range-slider',{attrs:{"label":"Font Size","sid":`.--${_vm.section.sid} .comments-box .comment-text`,"rule-name":"font-size","default-dimension":"px","dimensions":[]}}),_c('sid-font',{attrs:{"sid":`.--${_vm.section.sid} .comments-box .comment-text`}}),_c('sid-background',{attrs:{"sid":`.--${_vm.section.sid} .comments-box .comment-text`}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.section.sid} .comments-box .comment-text`,"rule-name":"border-style","searchable":false,"options":[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.section.sid} .comments-box .comment-text`,"label":"Border Width","rule-name":"border","css-var":"--border-size","angles":[
          {
            text: '',
            value: 'top-width'
          },
          {
            text: '',
            value: 'right-width'
          },
          {
            text: '',
            value: 'bottom-width'
          },
          {
            text: '',
            value: 'left-width'
          }
        ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid} .comments-box .comment-text`,"rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{attrs:{"label":"Radius","sid":`.--${_vm.section.sid} .comments-box .comment-text`,"rule-name":"border","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
        {
          text: '',
          value: 'top-left-radius',
          cssVar: '--border-top-left-radius'
        },
        {
          text: '',
          value: 'top-right-radius',
          cssVar: '--border-top-right-radius'
        },
        {
          text: '',
          value: 'bottom-left-radius',
          cssVar: '--border-bottom-left-radius'
        },
        {
          text: '',
          value: 'bottom-right-radius',
          cssVar: '--border-bottom-right-radius'
        }
      ]}}),_c('b-form-group',{attrs:{"label":"Shadow"}},[_c('sid-box-shadow',{attrs:{"sid":`.--${_vm.section.sid} .comments-box .comment-text`,"rule-name":"box-shadow"}})],1),_c('sid-linked-group',{attrs:{"label":"Padding","sid":`.--${_vm.section.sid} .comments-box .comment-text`,"rule-name":"padding","min":0,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Author"}},[_c('b-form-group',{attrs:{"label":"Text Color"}},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid} .comments-box .comment-user-name`,"rule-name":"color"}})],1),_c('sid-range-slider',{attrs:{"label":"Font Size","sid":`.--${_vm.section.sid} .comments-box .comment-user-name`,"rule-name":"font-size","default-dimension":"px","dimensions":[]}}),_c('sid-font',{attrs:{"sid":`.--${_vm.section.sid} .comments-box .comment-user-name`}})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Date"}},[_c('b-form-group',{attrs:{"label":"Text Color"}},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid} .comments-box .comment-date`,"rule-name":"color"}})],1),_c('sid-range-slider',{attrs:{"label":"Font Size","sid":`.--${_vm.section.sid} .comments-box .comment-date`,"rule-name":"font-size","default-dimension":"px","dimensions":[]}}),_c('sid-font',{attrs:{"sid":`.--${_vm.section.sid} .comments-box .comment-date`}})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Total Comments"}},[_c('b-form-group',{attrs:{"label":"Text Color"}},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid} .total-comments`,"rule-name":"color"}})],1),_c('sid-range-slider',{attrs:{"label":"Font Size","sid":`.--${_vm.section.sid} .total-comments`,"rule-name":"font-size","default-dimension":"px","dimensions":[]}}),_c('sid-font',{attrs:{"sid":`.--${_vm.section.sid} .total-comments`}}),_c('sid-align',{attrs:{"label":"Text Align","rule-name":"text-align","sid":`.--${_vm.section.sid} .total-comments`}}),_c('sid-linked-group',{attrs:{"label":"Padding","sid":`.--${_vm.section.sid} .total-comments`,"rule-name":"padding","min":0,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}}),_c('sid-linked-group',{attrs:{"label":"Margin","sid":`.--${_vm.section.sid} .total-comments`,"rule-name":"margin","min":0,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Reply Button"}},[_c('rule-tabs',{scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('b-form-group',{attrs:{"label":"Text Color"}},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid} .comment-reply-button`,"rule-name":"color"}})],1)]},proxy:true},{key:"Hover",fn:function(){return [_c('b-form-group',{attrs:{"label":"Text Color"}},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid} .comment-reply-button:hover`,"rule-name":"color","presudo":":hover"}})],1)]},proxy:true}])}),_c('sid-range-slider',{attrs:{"label":"Font Size","sid":`.--${_vm.section.sid} .comment-reply-button`,"rule-name":"font-size","default-dimension":"px","dimensions":[]}}),_c('sid-font',{attrs:{"sid":`.--${_vm.section.sid} .comment-reply-button`}})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Fields"}},[_c('sid-range-slider',{attrs:{"rule-name":"width","sid":`.--${_vm.section.sid}.comments-container input.comment-field`,"default-dimension":"px","dimensions":['%', 'vw', 'px'],"label":"Input Width","var":"--width","measurement":"width"}}),_c('sid-checkbox',{attrs:{"sid":`.--${_vm.section.sid} .guest-details`,"rule-name":"flex-wrap","value":"nowrap"}},[_vm._v(" No Wrap ")]),_c('sid-align',{attrs:{"sid":`.--${_vm.section.sid} .guest-details`,"rule-name":"justify-content","label":"Alignment"}}),_c('b-form-group',{attrs:{"label":"Text Color"}},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}.comments-container .comment-field`,"rule-name":"color"}})],1),_c('b-form-group',{attrs:{"label":"Placeholder Color"}},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}.comments-container .comment-field::placeholder`,"rule-name":"color"}})],1),_c('sid-range-slider',{attrs:{"label":"Font Size","sid":`.--${_vm.section.sid}.comments-container .comment-field`,"rule-name":"font-size","default-dimension":"px","dimensions":[]}}),_c('sid-font',{attrs:{"sid":`.--${_vm.section.sid}.comments-container .comment-field`}}),_c('sid-background',{attrs:{"sid":`.--${_vm.section.sid}.comments-container .comment-field`}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.section.sid}.comments-container .comment-field`,"rule-name":"border-style","searchable":false,"options":[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.section.sid}.comments-container .comment-field`,"label":"Border Width","rule-name":"border","css-var":"--border-size","angles":[
          {
            text: '',
            value: 'top-width'
          },
          {
            text: '',
            value: 'right-width'
          },
          {
            text: '',
            value: 'bottom-width'
          },
          {
            text: '',
            value: 'left-width'
          }
        ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}.comments-container .comment-field`,"rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{attrs:{"label":"Radius","sid":`.--${_vm.section.sid}.comments-container .comment-field`,"rule-name":"border","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
        {
          text: '',
          value: 'top-left-radius',
          cssVar: '--border-top-left-radius'
        },
        {
          text: '',
          value: 'top-right-radius',
          cssVar: '--border-top-right-radius'
        },
        {
          text: '',
          value: 'bottom-left-radius',
          cssVar: '--border-bottom-left-radius'
        },
        {
          text: '',
          value: 'bottom-right-radius',
          cssVar: '--border-bottom-right-radius'
        }
      ]}}),_c('b-form-group',{attrs:{"label":"Shadow"}},[_c('sid-box-shadow',{attrs:{"sid":`.--${_vm.section.sid}.comments-container .comment-field`,"rule-name":"box-shadow"}})],1)],1),_c('SidbearSettingsGroup',{attrs:{"title":"Button"}},[_c('rule-tabs',{scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('b-form-group',{attrs:{"label":"Button Text"}},[_c('b-input',{model:{value:(_vm.section.options.content.comments.btnText),callback:function ($$v) {_vm.$set(_vm.section.options.content.comments, "btnText", $$v)},expression:"section.options.content.comments.btnText"}})],1),_c('b-form-group',{attrs:{"label":"Text Color"}},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}.comments-container button`,"rule-name":"color"}})],1),_c('sid-range-slider',{attrs:{"label":"Font Size","sid":`.--${_vm.section.sid}.comments-container button`,"rule-name":"font-size","default-dimension":"px","dimensions":[]}}),_c('sid-font',{attrs:{"sid":`.--${_vm.section.sid}.comments-container button`}}),_c('sid-background',{attrs:{"sid":`.--${_vm.section.sid}.comments-container button`}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.section.sid}.comments-container button`,"rule-name":"border-style","searchable":false,"options":[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.section.sid}.comments-container button`,"label":"Border Width","rule-name":"border","css-var":"--border-size","angles":[
              {
                text: '',
                value: 'top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}.comments-container button`,"rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{attrs:{"label":"Radius","sid":`.--${_vm.section.sid}.comments-container button`,"rule-name":"border","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
            {
              text: '',
              value: 'top-left-radius',
              cssVar: '--border-top-left-radius'
            },
            {
              text: '',
              value: 'top-right-radius',
              cssVar: '--border-top-right-radius'
            },
            {
              text: '',
              value: 'bottom-left-radius',
              cssVar: '--border-bottom-left-radius'
            },
            {
              text: '',
              value: 'bottom-right-radius',
              cssVar: '--border-bottom-right-radius'
            }
          ]}}),_c('b-form-group',{attrs:{"label":"Shadow"}},[_c('sid-box-shadow',{attrs:{"sid":`.--${_vm.section.sid}.comments-container button`,"rule-name":"box-shadow"}})],1),_c('sid-linked-group',{attrs:{"label":"Padding","sid":`.--${_vm.section.sid}.comments-container button`,"rule-name":"padding","min":0,"angles":[
            {
              text: '',
              value: 'top'
            },
            {
              text: '',
              value: 'right'
            },
            {
              text: '',
              value: 'bottom'
            },
            {
              text: '',
              value: 'left'
            }
          ]}})]},proxy:true},{key:"Hover",fn:function(){return [_c('b-form-group',{attrs:{"label":"Text Color"}},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}.comments-container button`,"rule-name":"color","presudo":":hover"}})],1),_c('sid-background',{attrs:{"sid":`.--${_vm.section.sid}.comments-container button`,"presudo":":hover"}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.section.sid}.comments-container button`,"rule-name":"border-style","searchable":false,"presudo":":hover","options":[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.section.sid}.comments-container button`,"label":"Border Width","rule-name":"border","presudo":":hover","css-var":"--border-size","angles":[
              {
                text: '',
                value: 'top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}.comments-container button`,"rule-name":"border-color","presudo":":hover"}})],1)],1),_c('b-form-group',{attrs:{"label":"Shadow"}},[_c('sid-box-shadow',{attrs:{"sid":`.--${_vm.section.sid}.comments-container button`,"rule-name":"box-shadow","presudo":":hover"}})],1)]},proxy:true}])})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Padding & Margins"}},[_c('sid-linked-group',{attrs:{"label":"Padding","sid":`.--${_vm.section.sid}.comments-container`,"rule-name":"padding","min":0,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}}),_c('sid-linked-group',{attrs:{"label":"Margin","sid":`.--${_vm.section.sid}.comments-container`,"rule-name":"margin","min":-2000,"max":2000,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }